<div *ngIf="options.length>0" class="autoc-container">
  <form class="example-form">
    <mat-form-field appearance="fill" class="example-full-width appearance-fill w-100 mb-3">
      <input type="text"
          placeholder="Véhicule ..."
          aria-label="Plaque du Véhicule"
          matInput
          [formControl]="myControl"
          [readonly]="disabled || options.length==0"
          [matAutocomplete]="auto"
          >
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of options of filteredOptions | async" (click)="selectedCardata(option)" [value]="option.name">
          <div class="w-100 d-flex flex-row align-items-center justify-content-start">
            <i class="fas fa-car-side"></i>
            <p style="font-size: 12px;margin-left: 5px;margin-top:10px">{{option.name}}</p>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <ng-template [ngIf]="isloading">
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    </ng-template>
  </form>
</div>

<div *ngIf="options.length==0" class="autoc-container">
  <form class="example-form">
    <mat-form-field appearance="fill" class="example-full-width appearance-fill w-100 mb-3">
      <input type="text"
          placeholder="Véhicule..."
          aria-label="Plaque du Véhicule"
          matInput
          [formControl]="myControl"
          readonly="true"
          [matAutocomplete]="auto"
          style="color:red"
        >
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option>
          <div class="w-100 d-flex flex-row align-items-center justify-content-start">
            <p style="font-size: 12px;margin-left: 5px;margin-top:10px;">La table est vide</p>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <ng-template [ngIf]="isloading">
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    </ng-template>
  </form>
</div>

